import React from 'react';
import Container from '../Container';
import Button from '../Button';
import { MdOutlineFactCheck } from 'react-icons/md';
import { LuSquareKanban } from 'react-icons/lu';

export default function HeroSection() {
  return (
    <section id="accueil" className="relative overflow-hidden">
      <div className="pointer-events-none absolute left-10 top-8 h-5 w-5 rounded-full z-10 bg-[#FBCBA3]" />
      <div className="pointer-events-none absolute left-16 top-[180px] z-10 rotate-12">
        <div className="h-12 w-12 rounded-lg bg-[#008180] text-white text-4xl flex items-center justify-center shadow-md">
          <LuSquareKanban />
        </div>
      </div>
      <div className="pointer-events-none absolute right-24 z-10 top-16 -rotate-[20deg]">
        <div className="h-12 w-12 rounded-lg bg-[#FEA12B] text-white flex items-center justify-center text-4xl shadow-md">
          <MdOutlineFactCheck />
        </div>
      </div>
      <div className="pointer-events-none absolute right-24 top-64 h-52 w-52 dots-grid rounded-xl" />

      <Container className="py- md:py-12 z-10 pb-0 relative text-center">
        <h1 className="font-montserrat text-3xl md:text-5xl text-center tracking-[-0.02em] font-semibold text-[#2B2B2B] capitalize">
          <span className="text-shadow-hero">Gérez Toutes Vos Activités</span>
          <span className="block mt-5">Sur Une Seule Plateforme.</span>
        </h1>
        <div className="flex items-center justify-center relative">
          <div
            className="w-[435px] h-[35px] absolute right-[280px] opacity-100"
            style={{
              background:
                'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.89) 45.75%, #FFFFFF 100%)',
            }}
          ></div>
        </div>

        <div className="relative mx-auto mt-6 h-8 mb-4 w-[330px] z-10 max-w-3xl">
          <svg
            className="absolute left-0 right-0 mx-auto"
            width="100%"
            height="52"
            viewBox="0 0 600 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 27 C 50 0, 450 0, 595 27"
              stroke="#008180"
              strokeWidth="8"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <p className="font-script font-normal text-md md:text-[50px] leading-[120%] tracking-[-1%] text-[#2D2F2E] text-center capitalize">
          Simple, Moderne Et Connectée.
        </p>

        <div className="mt-10 flex items-center justify-center gap-4">
          <Button className="btn-pill btn-orange px-6 py-3 text-base font-semibold">
            Découvrir
            <span className="ml-2">→</span>
          </Button>
          <Button
            as="a"
            href="#tarifs"
            className="btn-pill btn-outline-orange hover:text-white px-6 py-3 text-base font-semibold"
          >
            Commencer gratuitement
          </Button>
        </div>
      </Container>
    </section>
  );
}
